import { frontendUrl } from '@/helpers/globals';
import type { CustomerVariables } from '@/@types/globals';
import { defineVariables } from '@/customer_specific/build/js-variables';

const thisYear = new Date().getFullYear();
const defaults = {
    logo: { image: '', width: 0, height: 0, alt: '' },
    signupUrl: '/service/meineveranstaltungen',
    loginFooterHtml: `
        <p class="tgk-paragraph-text">
        (c) 2009-${thisYear} thurgaukultur.ch. All rights reserved.<br>
        <a href="https://www.thurgaukultur.ch/service/genre/ueber-uns/sub/datenschutzerklaerung">Datenschutz</a> |
        <a href="https://www.thurgaukultur.ch/service/genre/ueber-uns/sub/impressum">Impressum</a>
        </p>
        `,
    vuetifyThemeColors: {
        primary: '#E3004F',
        primaryToggled: '#B80040',
        secondary: '#424242',
        anchor: '#E3004F',
        accent: '#82B1FF',
        action: '#E3004F',
        error: '#FF5252',
        attention: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
    },
    mainNavDrawerCollapseIconColor: 'primary',
} as CustomerVariables;

const customerValues = defineVariables(defaults);

export function vuetifyThemeColors() {
    return customerValues?.vuetifyThemeColors ? customerValues.vuetifyThemeColors : {};
}

export function signupUrl() {
    return frontendUrl(customerValues.signupUrl || '');
}

export function loginFooterHtml() {
    return customerValues.loginFooterHtml || '';
}

export function logo() {
    return customerValues.logo || '';
}

export function mainNavDrawerCollapseIconColor() {
    return customerValues.mainNavDrawerCollapseIconColor || 'primary';
}
